export async function handleDiscountApplication({
    promoApi,
    payload,
    button = null,
    loadingText = null,
    onSuccess,
    onFailure,
}) {
    const previousContent = button ? button.innerHTML : null;

    if (button) {
        button.disabled = true;
        if (loadingText) {
            button.innerHTML = loadingText;
        }
    }

    try {
        const response = await promoApi.applyDiscount(payload);

        if (response && response.success) {
            onSuccess?.(response);
        } else {
            onFailure?.(response?.message);
        }
    } catch (error) {
        onFailure?.();
    } finally {
        if (button) {
            button.disabled = false;
            if (loadingText) {
                button.innerHTML = previousContent;
            }
        }
    }
}